import values from 'lodash/values';
import PropTypes from 'prop-types';
import React from 'react';

import PlaySmallIcon from '../../../../../static/icons/ic_play_small_24.svg';
import QATags from '../../../../constants/QATags';
import { handlerNoPropagate } from '../../../../lib/EventUtils';
import Icon from '../../../Icon/Icon';

import './RowItemRightColumnPlayButton.scss';

const RowItemRightColumnPlayButton = React.memo(({ onlyShowRightColPlay, onClick, qaTag }) => {
  if (!onlyShowRightColPlay) {
    return null;
  }

  const click = handlerNoPropagate(onClick);

  return (
    <button type='button' className='RowItemRightColumnPlayButton ' data-qa={qaTag} onClick={click}>
      <Icon className='iconRightColButtonPlay' glyph={PlaySmallIcon} />
    </button>
  );
});

RowItemRightColumnPlayButton.propTypes = {
  onlyShowRightColPlay: PropTypes.bool,
  onClick: PropTypes.func,
  qaTag: PropTypes.oneOf(values(QATags)),
};

export default RowItemRightColumnPlayButton;
